import * as React from "react";
import * as ReactDOM from "react-dom";
import {Provider} from "react-redux";
import {Switch, Route, HashRouter} from "react-router-dom";

import store, {history} from "load/store";
import {ConnectedRouter} from "connected-react-router";
import {defaultState as appState} from "login/reducer";

import Logout from "logout";
import NotFoundPage from "notfound.tsx";
import App from "app";
import ChatApp from "app/chatroomapp";

function getRoutes() {
    return (
        <HashRouter>
            <Switch>
                <Route exact path="/logout" component={Logout} />
                <Route path="/:id?/" component={(props) => <App {...props} version={2}/>}/>
                <Route exact path="*" component={NotFoundPage} />
                <Route exact path="/chat" component={ChatApp} />
            </Switch>
        </HashRouter>
    );
}
ReactDOM.render(
    <Provider store={store({ login: appState })}>
        <ConnectedRouter history={history}>
            {getRoutes()}
        </ConnectedRouter>
    </Provider>,
    document.getElementById("root"),
);
